import { GetNetworkQuery } from '@coris-ts/repository/query/network.query'
import { type HttpParameters } from '@coris-ts/data/parameter-type'
import { ApiEndpoint } from '../../../../shared/api-endpoint'
import { type ActivityType } from '../../domain/models/engagement-users'

export class GetUsersTotalsQuery extends GetNetworkQuery {
  constructor(
    private readonly fromDate: string,
    private readonly toDate: string,
    private readonly activityType: ActivityType,
    private readonly organization: string
  ) {
    super(ApiEndpoint.UsersTotals)
  }

  public get queryParameters(): HttpParameters {
    return {
      from_date: this.fromDate,
      to_date: this.toDate,
      activity_type: this.activityType,
      organization: this.organization
    }
  }
}
